<template>
  <v-row>
    <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'} mx-auto`" documents>
      <v-card class="elevation-0">
        <Paging
          :resourceSettings="resourceSettings"
          :resource="documents"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>
          <v-row>
            <v-col md="3" cols="12" FILTERS>
              <v-select 
                small 
                outlined 
                dense 
                autocomplete="disabled"
                hide-details
                :items="filter_types"
                v-model="type"
                item-text="ar"
                item-value="slug"
                :label="i18n.document_type"
                @change="filterLeads()"
                >
                <template v-slot:selection="{item}">
                  <span class="arFont text-right">{{ item.ar }}</span>
                </template>
                <template v-slot:item="{item}">
                  <span class="arFont text-right">{{ item.ar }}</span>
                </template>
              </v-select>
            </v-col>
            <v-col sm="1" cols="12" class="ml-auto">
              <v-btn block @click.stop="$emit('openDialog', 'document')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <ListDocuments
            @copyS="clipboardSuccessHandler"
            @editResource="(name, model) => $emit('editResource', name, model)"
            @deleteResource="(name, model) => $emit('deleteResource', name, model)"
            v-if="documents.data && documents.data.length > 0"
            :documents="documents.data"
            :types="types"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ListDocuments from "./listDocuments.vue";
import Paging from "@/components/Paging";

export default {
  props: ["documents"],
  components: { ListDocuments, Paging },
  data() {
    return {
      type: null,
      types: [
        { slug: "other", ar: "مستندات اخرى" },
        { slug: "cv", ar: "سيرة ذاتية" },
        { slug: "portrait", ar: "صورة شخصية" },
        { slug: "certificate", ar: "شهادة" },
        { slug: "school_certificate", ar: "شهادة مدرسية" },
        { slug: "uni_certificate", ar: "شهادة جامعية" },
        { slug: "b_1_certificate", ar: "شهادة مستوى B1" },
        { slug: "b_2_certificate", ar: "شهادة مستوى B2" },
        { slug: "visa", ar: "نسخة عن التأشيرة" },
      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    filter_types() {
      return [{ slug: null, ar: "جميع المستندات" }, ...this.types]
    },
    user() {
      return this.$store.state.user;
    },
    language() {
      return this.$store.state.language;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.type) {
        filter += `?filter[type]=${this.type}`
      }

      return filter;
    },
    filterLeads() {
      this.loadResource()
    },
    clipboardSuccessHandler() {
      this.$emit('copyS')
    },
    loadResource() {
      console.log(this.buildFilter());
      this.$emit("loadResource", "documents", "documents", this.buildFilter());
    },
    pageByNumber(page) {
      this.$emit("pageByNumber", "documents", "documents", page);
    },
  },
};
</script>
